// test609
(609 && 0);
